import { useUserStore } from '@/stores/User.store'
import { useJwt } from '@vueuse/integrations/useJwt'
import type { IUserData } from '@/stores/types'
import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) return

  const runtimeConfig = useRuntimeConfig()
  const jwt = useCookie<string>(runtimeConfig.public.authCookieName, COOKIE_OPTIONS)

  if (!jwt) {
    return
  }

  const { payload } = useJwt<IUserData>(jwt)
  const userStore = useUserStore()

  if (payload.value === null) {
    userStore.logOutUser()
    return
  }

  if (userStore.isUserLogged) {
    return
  }

  userStore.setUserData(payload.value)
})
